import { system, LookupStorage } from "portalframework";
import * as ko from "knockout";
import * as _ from "lodash";
import { AddressBookSearchCriteria, address_book_record, searchResult, searchResultArray } from "organized";
import { BaseService } from "./_common/_baseService";
import { portalHttpService } from "./_common/httpService";

class AddressBookService extends BaseService {
  constructor() {
    super("addressBook");
  }

  public getAddressBookScreenData = async (): Promise<searchResult<any>> => {
    let requiredLookups = [];
    let lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    let data = ko.toJSON({ requiredLookups: lookupsToFetch });
    const result = await portalHttpService.post<any>(
      system.apiURL() + "api/" + this.controllerName + "/AddressBookListScreenData",
      data
    );
    _.each(lookupsToFetch, (lookupName) => {
      let list = result.result.results[lookupName];
      if (list) {
        LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
      }
    });
    return result;
  };

  public searchRecords = async (criteria: AddressBookSearchCriteria): Promise<searchResult<address_book_record[]>> => {
    const data: searchResult<any[]> = await portalHttpService.post<any>(
      `${this.baseApiUrl()}/SearchAddresses`,
      ko.toJSON(criteria)
    );
    data.result = data.result.map((ad) => new address_book_record(ad));

    return data;
  };

  public searchAllRecords = async (
    criteria: AddressBookSearchCriteria
  ): Promise<searchResultArray<address_book_record>> => {
    let params = ko.toJSON({ ...criteria });
    const data: searchResultArray<any> = await portalHttpService.post<any>(
      system.apiURL() + "api/" + this.controllerName + "/SearchAllAddresses",
      params
    );

    let result: address_book_record[] = [];
    if ((data?.result?.length ?? -1) > 0) {
      result = data.result.map((d) => new address_book_record(d));
    }

    return new searchResultArray<address_book_record>({ result, count: 0 });
  };

  public getAddress = async (id?: string): Promise<address_book_record> => {
    const result = await portalHttpService.get<any>(
      system.apiURL() + "api/" + this.controllerName + "/GetAddress/" + id
    );
    let addressBookRecord: address_book_record = null;
    if (result) {
      addressBookRecord = new address_book_record(result);
    }
    return addressBookRecord;
  };

  public addAddressBookRecord = async (addressBookRecord: address_book_record): Promise<address_book_record> => {
    const params = ko.toJSON(addressBookRecord);
    const result = await portalHttpService.post<any>(
      system.apiURL() + "api/" + this.controllerName + "/AddAddress",
      params
    );
    return new address_book_record(result);
  };
  public editAddressBookRecord = async (addressBookRecord: address_book_record): Promise<address_book_record> => {
    const params = ko.toJSON(addressBookRecord);
    const result = await portalHttpService.post<any>(
      system.apiURL() + "api/" + this.controllerName + "/EditAddress",
      params
    );
    return new address_book_record(result);
  };

  public deleteAddressBookRecord = async (addressBookRecord: address_book_record) => {
    return await portalHttpService.post<any>(
      system.apiURL() + "api/" + this.controllerName + "/DeleteAddress",
      ko.toJSON(addressBookRecord)
    );
  };
}

export const addressBookService = new AddressBookService();
